export * from '@primeuix/themes/nora/dialog';
export { default } from '@primeuix/themes/nora/dialog';
